<template>
    <div class="text-wraper" :class="customClass">
        <label
            class="text-label"
            v-if="isShowLabel"
            :class="{
                error: !isFirstSave && isShowErrorLbl && !errorInfo.isValid,
            }"
            :for="id"
            >{{ label }}</label
        >
        <div class="input-box">
            <input
                :id="id"
                type="text"
                class="input-field"
                :class="{
                    error: !errEmail && content != '' && content != null,
                }"
                :maxlength="maxLength"
                :readonly="readOnly"
                :placeholder="placeholder"
                v-model="content"
                @input="onChange(content)"
            />
            <div class="dash"></div>
            <!-- <span
                class="placeholder"
                :class="{
                    error: !errEmail && content != '' && content != null
                }"
                v-show="!content"
                >อีเมล(ถ้ามี)</span
            > -->
        </div>
        <div
            class="error-text err-mb-20"
            v-if="!errEmail && content != '' && content != null"
        >
            รูปแบบของอีเมลไม่ถูกต้อง
        </div>
        <!-- <div class="error-text"
             v-if="isShowErrorLbl"
             v-show="!isFirstSave && !errorInfo.isValid">{{errorInfo.msg}}</div> -->
    </div>
</template>
<script>
import Vue from "vue";
import Util from "@/helper/Utility.js";
/**
 * Property
 * @property {string} inputId (required) Field id for emit.
 * @property {object} inputLbl (required) Text for component.
 * @property {number} inputMinLength (optional) Minimum length.
 * @property {number} inputMaxLength (optional) Maximum Length.
 * @property {boolean} isFirstSave (required) Show/Hide Error after save.
 * @property {boolean} isShowErrorLbl (optional) Show/Hide Error label.
 * @property {object} errorInfo (optional) example : { isValid: true, msg: '',}
 * @property {boolean} blockAutoComplete (optional) Block borwser auto complete field.
 * @property {string} addClass (optional) Add css class
 * Event
 * @event onChange Filter and validate.
 * Method
 * @method validateInput Validate text.
 */
export default {
    name: "Email",
    props: {
        //v-model
        value: String,
        //props
        inputId: String,
        inputLbl: Object,
        inputMinLength: Number,
        inputMaxLength: Number,
        isFirstSave: Boolean,
        isShowErrorLbl: Boolean,
        errorInfo: Object,
        blockAutoComplete: Boolean,
        addClass: String,
        isShowLabel: Boolean,
    },
    data: function () {
        return {
            id: "",
            label: "",
            placeholder: "",
            content: this.value,
            minLength: 0,
            maxLength: 0,
            readOnly: true,
            customClass: "",
            errEmail: false,
        };
    },
    watch: {
        value(newVal, oldVal) {
            if (newVal != oldVal) {
                this.content = newVal;
                this.validateInput(this.content);
            }
        },
    },
    mounted: function () {
        this.id = this.inputId;
        this.label = this.inputLbl.name;
        this.placeholder = "example@email.com" || this.inputLbl.placeholder;
        this.minLength = this.inputMinLength || null;
        this.maxLength = this.inputMaxLength || null;
        this.customClass = this.addClass || "";
        this.validateInput();

        this.readOnly = this.blockAutoComplete;
        setTimeout(() => {
            this.readOnly = false;
        }, 500);
    },
    methods: {
        validateInput: function () {
            if (!this.inputLbl) return;

            this.errEmail = this.validEmail(this.content);
            if (this.errEmail) this.errorInfo.isValid = true;
            //Set default.
            // this.errorInfo.isValid = true;
            this.errorInfo.msg = "";
            //Required
            if (this.inputLbl.required && Util.isEmptyStr(this.content)) {
                // this.errorInfo.isValid = false;
                this.errorInfo.msg = this.inputLbl.required;
                return;
            }
            //Too short
            if (this.inputLbl.too_short && this.content < this.minLength) {
                this.errorInfo.isValid = false;
                this.errorInfo.msg = Util.stringFormat(
                    this.inputLbl.too_short,
                    this.minLength
                );
                return;
            }
            //InValid format
            if (this.inputLbl.invalid) {
                if (!Vue.validator.validateEmail(this.content)) {
                    this.errorInfo.isValid = false;
                    this.errorInfo.msg = this.inputLbl.invalid;
                    return;
                }
            }
        },
        onChange: function (content) {
            var result = this.content;
            if (result == "") this.errorInfo.isValid = true;

            if (result != "") {
                this.errEmail = this.validEmail(content);
                if (!this.errEmail) this.errorInfo.isValid = false;
            }

            //Remove restrict character.
            result = result.replace(/[\u0E00-\u0E7F]/g, "");

            this.content = result;

            if (result !== this.content) {
                this.validateInput();
            }

            this.$emit("input", result);
            if (content.length > 0) {
                this.errEmail = this.validEmail(result);

                if (!this.errEmail) {
                    this.errorInfo.isValid = false;
                } else {
                    this.errorInfo.isValid = true;
                }
                console.log("check validate", this.errorInfo.isValid);
            }
        },
        validEmail: function (email) {
            const re =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/Input/Text.scss";
@import "@/style/_mixin.scss";
.text-wraper {
    color: $color-text-light !important;
    .input-box {
        color: $color-text-light !important;
        input {
            color: $color-text-light !important;
            width: 100%;
            background-color: transparent;
            border: none;
        }
        .dash {
            height: 2px;
            width: 100%;
            background-image: linear-gradient(
                to right,
                #6f5948 0%,
                #6f5948 50%,
                transparent 50%
            );
            background-size: 20px 2px;
            background-repeat: repeat-x;
        }
    }
}
</style>
